var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"18.46","height":"64.79","key":0}),React.createElement("rect",{"x":"29.84","width":"18.46","height":"64.79","key":1})]);
}

Pause.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 48.31 64.79"};

module.exports = Pause;

Pause.default = Pause;
